// THE END OF THE ADJUSTABLE TEXTBOX (2026-08-30, Yves' call): every `.form-textarea` in the
// operator console is a borderless field that GROWS with its text — no resize handle, no inner
// scrollbar, ever. The look lives in main.css (quiet at rest, hover shows the field, focus
// shows commitment — the bench's ✎ idiom, app-wide); THIS module keeps the heights true.
//
// One document-level installation instead of 33 call-site conversions: a delegated input
// listener fits the field being typed in, and a rAF-debounced MutationObserver re-fits them
// all whenever React re-renders anything — which also covers programmatic fills (a FieldChat
// "take", a keyed remount, a modal opening on prefilled text). Fields are few and fit() is
// two style writes; the observer's worst case is invisible.
const fit = (el: HTMLTextAreaElement): void => {
  el.style.height = 'auto';
  el.style.height = `${el.scrollHeight + 2}px`;
};

const fitAll = (): void => {
  document.querySelectorAll<HTMLTextAreaElement>('textarea.form-textarea').forEach(fit);
};

export function installGrowingTextareas(): void {
  document.addEventListener(
    'input',
    (e) => {
      const t = e.target;
      if (t instanceof HTMLTextAreaElement && t.classList.contains('form-textarea')) fit(t);
    },
    true,
  );
  let raf = 0;
  const observer = new MutationObserver(() => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(fitAll);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  fitAll();
}
